'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PhotoCarouselRootContext } from './context/photo-carousel-root.context';
import { photoCarouselNavControlsStyles } from './styles/photo-carousel-nav-controls.styles';
import type { PhotoCarouselNavControlsPropsInterface } from './types/photo-carousel-nav-controls.types';

/**
 * Container for the "Previous photo" and "Next photo" nav controls.
 *
 * @related ['IconButton']
 * @since 8.66.0
 */

export const PhotoCarouselNavControls = forwardRef<
  HTMLDivElement,
  PhotoCarouselNavControlsPropsInterface
>((props: PhotoCarouselNavControlsPropsInterface, forwardedRef) => {
  const { totalSlides = 0 } = useContext(PhotoCarouselRootContext);

  // Only show controls if there are 2 or more slides.
  if (totalSlides < 2) {
    return null;
  }

  const { className, css: cssProp, ...rest } = props;

  const styles = css(photoCarouselNavControlsStyles, cssProp);

  return (
    <div
      className={cx('c11n', styles, className)}
      data-c11n-component="PhotoCarousel.NavControls"
      data-c11n-version={__C11N_VERSION__}
      ref={forwardedRef}
      {...rest}
    />
  );
});

PhotoCarouselNavControls.displayName = 'PhotoCarousel.NavControls';
